import BarChart from "components/charts/BarChart";
import Card from "components/card";
import { useEffect, useState } from "react";
import { BiMessageAltError } from "react-icons/bi";

const DailyTraffic = (props) => {
  const [formattedData, setFormattedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [barChartDataDailyTraffic, setBarChartDataDailyTraffic] = useState([]);
  const [barChartOptionsDailyTraffic, setBarChartOptionsDailyTraffic] =
    useState({});
  // Format data once frequencyData is available

  useEffect(() => {
    setLoading(true);
    if (props?.frequencyData) {
      const updatedData = props.frequencyData;
      setFormattedData(updatedData);
      setLoading(false);
    } else {
      setFormattedData([]);
      setLoading(false);
    }
  }, [props?.frequencyData]);

  // Populate barChartData and barChartOptions dynamically
  useEffect(() => {
    setBarChartDataDailyTraffic([
      {
        name: "Daily Frequency",
        data: formattedData?.length
          ? formattedData?.map((item) => item?.Count)
          : [], // Use dynamic data
      },
    ]);
    setBarChartOptionsDailyTraffic({
      chart: {
        toolbar: {
          show: false,
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: undefined,
          backgroundColor: "#000000",
        },
        theme: "dark",
      },
      xaxis: {
        categories: formattedData?.length
          ? formattedData?.map((item) => item?.Date)
          : [], // Use dynamic categories
        labels: {
          show: true,
          style: {
            colors: "#A3AED0",
            fontSize: "14px",
            fontWeight: "500",
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        show: true,
        color: "black",
        labels: {
          show: true,
          style: {
            colors: "#CBD5E0",
            fontSize: "14px",
          },
        },
      },
      grid: {
        show: false,
        strokeDashArray: 5,
        yaxis: {
          lines: {
            show: true,
          },
        },
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          type: "vertical",
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          colorStops: [
            {
              offset: 0,
              color: "#00FF00", // Bright green at the top
              opacity: 1,
            },
            {
              offset: 100,
              color: "#00C49A", // Darker green at the bottom
              opacity: 0.9,
            },
          ],
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: "40px",
        },
      },
    });
  }, [formattedData?.length]);

  // const barChartOptionsDailyTraffic = {
  //   chart: {
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   tooltip: {
  //     style: {
  //       fontSize: "12px",
  //       fontFamily: undefined,
  //       backgroundColor: "#000000",
  //     },
  //     theme: "dark",
  //   },
  //   xaxis: {
  //     categories: formattedData?.map((item) => item?.Date), // Use dynamic categories
  //     labels: {
  //       show: true,
  //       style: {
  //         colors: "#A3AED0",
  //         fontSize: "14px",
  //         fontWeight: "500",
  //       },
  //     },
  //     axisBorder: {
  //       show: false,
  //     },
  //     axisTicks: {
  //       show: false,
  //     },
  //   },
  //   yaxis: {
  //     show: true,
  //     color: "black",
  //     labels: {
  //       show: true,
  //       style: {
  //         colors: "#CBD5E0",
  //         fontSize: "14px",
  //       },
  //     },
  //   },
  //   grid: {
  //     show: false,
  //     strokeDashArray: 5,
  //     yaxis: {
  //       lines: {
  //         show: true,
  //       },
  //     },
  //     xaxis: {
  //       lines: {
  //         show: false,
  //       },
  //     },
  //   },
  //   fill: {
  //     type: "gradient",
  //     gradient: {
  //       type: "vertical",
  //       shadeIntensity: 1,
  //       opacityFrom: 0.7,
  //       opacityTo: 0.9,
  //       colorStops: [
  //         {
  //           offset: 0,
  //           color: "#00FF00", // Bright green at the top
  //           opacity: 1,
  //         },
  //         {
  //           offset: 100,
  //           color: "#00C49A", // Darker green at the bottom
  //           opacity: 0.9,
  //         },
  //       ],
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   plotOptions: {
  //     bar: {
  //       borderRadius: 10,
  //       columnWidth: "40px",
  //     },
  //   },
  // };

  // Conditionally render the chart once formattedData is ready
  return (
    <Card extra="pb-7 p-[20px]">
      <div className="flex flex-row justify-between">
        <div className="ml-1 pt-2">
          <p className="text-sm font-medium leading-4 text-gray-600">
            Complaint Frequency
          </p>
          <p className="text-[34px] font-bold text-navy-700 dark:text-white">
            {formattedData?.length
              ? formattedData?.reduce((acc, curr) => curr.Count + acc, 0)
              : 0}
            <span className="text-sm font-medium leading-6 text-gray-600">
              Complaints
            </span>
          </p>
        </div>
      </div>

      <div className="h-[300px] w-full pb-0 pt-10">
        {props?.frequencyData ? (
          <>
            {formattedData.length > 0 &&
              !loading && ( // Render the chart only when data is available
                <BarChart
                  chartData={barChartDataDailyTraffic}
                  chartOptions={barChartOptionsDailyTraffic}
                />
              )}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center pt-20">
            <BiMessageAltError size={40} className="text-gray-500" />
            <p className="text-xl font-semibold text-gray-500">No Data Found</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default DailyTraffic;
